import * as angular from 'angular';
import { OrganizationResource } from '@mode/legacy/data-access-model-js';
import { OrganizationHelpers } from '@mode/legacy/data-access-model-js';

class GroupsController {
  private $resolve: any;
  private organization: OrganizationResource;

  $onInit() {
    this.organization = this.$resolve.organization._resource;
  }

  orgScimEnabled() {
    return OrganizationHelpers.IsScimEnabled(this.organization);
  }
}

export const GroupsComponent: angular.IComponentOptions = {
  controller: GroupsController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <groups-panel
      org-token="ctrl.$resolve.orgToken"
      org-username="ctrl.$resolve.orgUsername"
      user-is-admin="ctrl.$resolve.currentUserIsAdmin"
      org-scim-enabled="ctrl.orgScimEnabled()"
    />
  `,
};
